/**
 * Resolves a Liquid-extracted component name to a known store/allowlist name.
 * Matching is case-insensitive so casing differences (e.g. "image" vs "Image") still resolve.
 *
 * @param liquidComponentName - Name extracted from a message_component Liquid tag
 * @param knownComponentNames - Component names present in the store / allowlist
 * @returns The matching known name, or undefined when none match
 */
export const resolveComponentName = (
  liquidComponentName: string,
  knownComponentNames: Iterable<string>
): string | undefined => {
  if (liquidComponentName.length === 0) {
    return undefined;
  }

  const lower = liquidComponentName.toLowerCase();
  return Array.from(knownComponentNames).find((name) => name.toLowerCase() === lower);
};
